<div class="no-actions-message" role="presentation">
  <p>{{ params.noRowsMessageFunc() }}</p>
</div>
